import * as React from "react"
import {
  Sidebar,
  List,
  Divider,
  Icon,
  Input,
  InputOnChangeData,
} from "semantic-ui-react"
import MiniList from "./com_mini-list"
import { withRouter } from "react-router"
import { connect } from "react-redux"
import { Languages } from "../../../utils"
import SideBarListLegend from "./com_sidebar-list-legend"

import { fetchProducts, openSidebar, closeSidebar } from "../../../core/actions"
import * as _ from "lodash"
import {
  DropitState,
  getTranslationsByScope,
  isSidebarOpened,
} from "../../../core/reducers"
import Loading from "../com_loading"
import { IRawSupplierReference } from "../../../models"
import { getProductList } from "../../../core/reducers/red_products"
import { normalizeString } from "../../../utils/string"
import { stringify } from "../../../utils/stringifyier"

export interface ISideBarProps {
  loading: boolean
  products: IRawSupplierReference[]
  actualDroopyId: any
  activeLang: Languages
  open: boolean
  translations: any
  fetchProducts: () => void
  onOpen: () => void
  onClose: () => void
}

const CustomSideBar = React.memo(
  (props: ISideBarProps) => {
    const {
      products,
      actualDroopyId,
      open,
      onOpen,
      onClose,
      activeLang,
      translations,
      loading,
    } = props

    const [visible, setVisible] = React.useState(false)
    const [searchText, setSearchText] = React.useState("")

    React.useEffect(() => {
      if (products.length < 1) {
        props.fetchProducts()
      }
    }, [])

    const handleChangeSearch = (
      e: React.ChangeEvent<HTMLInputElement>,
      data: InputOnChangeData
    ) => {
      setSearchText(data.value)
    }

    const actualProduct = products.find((o) => o.droopyId === actualDroopyId)
    const deleted = !!actualProduct?.deleted
    // const productList = groupTopRefAndVariants(products, false)

    const searchedReferences =
      searchText.length <= 3
        ? []
        : products.filter((r) => {
            const coreMatch =
              r.label.some((s) =>
                normalizeString(s.value).includes(normalizeString(searchText))
              ) ||
              normalizeString(r.supplierRef).includes(
                normalizeString(searchText)
              )

            const declinedMatch =
              r.declined &&
              r.declined.some(
                (f) =>
                  f.label.some((s) =>
                    normalizeString(s.value).includes(
                      normalizeString(searchText)
                    )
                  ) ||
                  normalizeString(f.supplierRef).includes(
                    normalizeString(searchText)
                  )
              )

            return coreMatch || declinedMatch
          })

    const selectedReference: IRawSupplierReference[] =
      actualDroopyId && products.length > 1 && !deleted
        ? [
            products.find(
              (o) =>
                o.droopyId === actualDroopyId ||
                o.declined?.find((p) => p.droopyId === actualDroopyId)
            ) as IRawSupplierReference,
          ]
        : []

    const searchedList = (
      searchText.length > 3 ? searchedReferences : selectedReference
    ).filter((r) => !!r)

    const title =
      searchText.length > 3
        ? translations.researchResult
        : actualDroopyId === ""
        ? translations.noRefSelected
        : selectedReference[0]?.isTopRef
        ? translations.headAndDeclined
        : translations.selectedProduct

    return (
      <div>
        <div onMouseEnter={onOpen} onMouseLeave={onClose}>
          <button className="sidebar-button side-button-right">
            <Icon name="chevron left" style={{ padding: 0 }} />
            <br />
            <Icon name="chevron left" style={{ padding: 0 }} />
            <br />
            <Icon name="chevron left" style={{ padding: 0 }} />
          </button>

          <Sidebar
            animation="overlay"
            direction="right"
            inverted
            vertical
            visible={open}
            // visible={true}
          >
            <div className="sidebar-content">
              <div className="header-div">
                <h2 className="sidebar-header">{title}</h2>
                <Input
                  icon="search"
                  placeholder="4 char. min."
                  value={searchText}
                  onChange={handleChangeSearch}
                />
              </div>
              <Divider />
              <div className="sidebar-list">
                {loading && <Loading />}
                <List className={"product-list"}>
                  {Object.values(searchedList).map(
                    (product: IRawSupplierReference, i: number) => [
                      <MiniList
                        translations={translations}
                        key={i}
                        productTree={product}
                        activeLang={activeLang}
                        onClick={onClose}
                      />,
                      i === 0 && actualDroopyId && !deleted ? (
                        <Divider key={"divider"} />
                      ) : null,
                    ]
                  )}
                </List>
                <SideBarListLegend />
              </div>
            </div>
          </Sidebar>
        </div>
        {/* {window.localStorage.getItem(LocalStorageKeys.SIDEBAR_SHOWED) !==
        "true" && products.length > 0
        ? (window.localStorage.setItem(LocalStorageKeys.SIDEBAR_SHOWED, "true"),
          generateDemo())
        : ""} */}
      </div>
    )
  },
  (prevProps, nextProps) => {
    return (
      stringify(nextProps.products) === stringify(prevProps.products) &&
      stringify(prevProps.open) === stringify(nextProps.open) &&
      stringify(prevProps.translations) === stringify(nextProps.translations) &&
      stringify(prevProps.actualDroopyId) ===
        stringify(nextProps.actualDroopyId) &&
      stringify(prevProps.loading) === stringify(nextProps.loading)
    )
  }
)

const mapStateToProps = (state: DropitState, ownProps: any) => ({
  loading: state.loading.productsAreLoading > 0,
  products: getProductList(state),
  open: isSidebarOpened(state),
  translations: getTranslationsByScope(state, "sideBar"),
})

const mapDispatchToProps = {
  fetchProducts,
  onOpen: openSidebar,
  onClose: closeSidebar,
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(CustomSideBar)
)

// const generateDemo = () => {
//   return (
//     <div className={"sidebar-demo " + (open ? "sidebar-demo-opened" : "")}>
//       <h2 className="sidebar-demo-text">{translations.sidebarTutorial}</h2>
//       <Icon
//         className="sidebar-demo-icon sidebar-hint-icon"
//         name="arrow right"
//         size="massive"
//       />
//     </div>
//   )
// }
